/**
 * @generated SignedSource<<944831b87f11b0402bf7a82d60070f71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RateCardUpdateActiveMutation$variables = {
  active: boolean;
  id: number;
};
export type RateCardUpdateActiveMutation$data = {
  readonly updateRateCardActive: {
    readonly rate_card: {
      readonly active: boolean;
      readonly id: number;
    } | null | undefined;
  };
};
export type RateCardUpdateActiveMutation = {
  response: RateCardUpdateActiveMutation$data;
  variables: RateCardUpdateActiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "active"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "active",
            "variableName": "active"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RateCardActiveUpdateOutput",
    "kind": "LinkedField",
    "name": "updateRateCardActive",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "rate_cards",
        "kind": "LinkedField",
        "name": "rate_card",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RateCardUpdateActiveMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RateCardUpdateActiveMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8d73f7f9ea4343256f966b91aa61cf3d",
    "id": null,
    "metadata": {},
    "name": "RateCardUpdateActiveMutation",
    "operationKind": "mutation",
    "text": "mutation RateCardUpdateActiveMutation(\n  $id: Int!\n  $active: Boolean!\n) {\n  updateRateCardActive(input: {id: $id, active: $active}) {\n    rate_card {\n      id\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ea47620b705123ecc4f238f553a7783";

export default node;
